import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { AppLoginSubjectContainerModel } from '../../../../../models/aggregates/id';
import { AppLoginContainerModel } from '../../../../../models/aggregates/id';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa, Pagination } from '../shared';
import { Observable } from 'rxjs';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../shared/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class TenantUserProfileService extends BaseApiTemplateService<AppLoginContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'user-profile';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'user-profile';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'user-profile';
    this.httpClient = http;
  }

  getByCriteriaWithPrincipalId(principalId: string, apiVisa: ApiVisa): Observable<PagingResponseModel<AppLoginSubjectContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/query?principalId=' + principalId;
    return this.httpClient.get<PagingResponseModel<AppLoginSubjectContainerModel>>(url, this.getHttpHeader(apiVisa));
  }

  getProfileName(visa: ApiVisa, guid: string): Observable<BasicApiResponseModel<string>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    const Url = url + '/name/' + guid;
    return this.httpClient.get<BasicApiResponseModel<string>>
      (Url, this.getHttpHeader(visa));
  }

  getProfileNamePromise(visa: ApiVisa, guid: string): Promise<BasicApiResponseModel<string>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    const Url = url + '/name/' + guid;
    return this.httpClient.get<BasicApiResponseModel<string>>
      (Url, this.getHttpHeader(visa)).toPromise();
  }

  getOwnProfile(apiVisa: ApiVisa): Observable<BasicApiResponseModel<AppLoginContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<AppLoginContainerModel>>(url, this.getHttpHeader(apiVisa));
  }


  getUserDetail(visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(url, this.getHttpHeader(visa));
  }

  sysadminGetOwnProfile(apiVisa: ApiVisa){
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/sysadmin-ep`;
    };

    return this.httpClient.get<BasicApiResponseModel<AppLoginContainerModel>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  sysadminGetProfileBySubjectGuid(guid: string, apiVisa: ApiVisa){
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/sysadmin-ep/${guid}`;
    };

    return this.httpClient.get<BasicApiResponseModel<AppLoginContainerModel>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/sysadmin-ep/query?${pagination.getQueryKeyValues()}`;
    };

    return this.httpClient.get<BasicApiResponseModel<AppLoginContainerModel>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  sysadminPut(dtoObject: AppLoginContainerModel, apiVisa: ApiVisa){
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/sysadmin-ep`;
    };

    return this.httpClient.put(this.apiUrl, dtoObject, this.getHttpHeader(apiVisa));
  }

   tenantEpGetByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/tenant-ep/' + guid,
      this.getHttpHeader(visa)
    );
  }

   tenantEpGetByCriteriaPromise(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Promise<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/tenant-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  tenantAdminPut(dtoObject: AppLoginContainerModel, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/tenant-admin-ep`;
    };

    return this.httpClient.put(this.apiUrl, dtoObject, this.getHttpHeader(apiVisa));
  }
}
